export const LEARN_ACTIVITIES = [
  {
    "_id": "6976a2016cb884ff5deae4b2",
    "topic": "Land & Nature",
    "question": "",
    "answer": false,
    "image": "/units/land_nature/images/It's raining.png",
    "audio": "/units/land_nature/audio/Ki-mi-on.m4a",
    "lesson_type": "learn",
    "id": "696a66c07bbf3e4de4b8dc5a",
    "status": "none",
    "active": true,
    "order": 1,
    "activity_type": "listen",
  },
  {
    "_id": "6976a2016cb884ff5deae4b3",
    "topic": "Land & Nature",
    "question": "",
    "answer": false,
    "image": "/units/land_nature/images/The snow is falling.png",
    "audio": "/units/land_nature/audio/Sok-pin.m4a",
    "lesson_type": "learn",
    "id": "696a8f0d7bbf3e4de4b8dc82",
    "status": "none",
    "active": true,
    "order": 2,
    "activity_type": "listen",
  },
  {
    "_id": "6976a2016cb884ff5deae4b4",
    "topic": "Land & Nature",
    "question": "",
    "answer": false,
    "image": "/units/land_nature/images/cold.png",
    "audio": "/units/land_nature/audio/Ki-si-na.m4a",
    "lesson_type": "learn",
    "id": "696a905b7bbf3e4de4b8dc93",
    "status": "none",
    "active": true,
    "order": 3,
    "activity_type": "listen",
  },
  {
    "_id": "6976a2016cb884ff5deae4b5",
    "topic": "Land & Nature",
    "question": "",
    "answer": false,
    "image": "/units/land_nature/images/warm.png",
    "audio": "/units/land_nature/audio/Ki-je-de.m4a",
    "lesson_type": "learn",
    "id": "696a90e37bbf3e4de4b8dc98",
    "status": "none",
    "active": true,
    "order": 4,
    "activity_type": "listen",
  },
  {
    "_id": "6976a2016cb884ff5deae4b6",
    "topic": "Land & Nature",
    "question": "",
    "answer": false,
    "image": "/units/land_nature/images/The sun is shining.png",
    "audio": "/units/land_nature/audio/Ki-ja-te.m4a",
    "lesson_type": "learn",
    "id": "696a92027bbf3e4de4b8dca9",
    "status": "none",
    "active": true,
    "order": 5,
    "activity_type": "listen",
  },
  {
    "_id": "6976a2016cb884ff5deae4b7",
    "topic": "Land & Nature",
    "question": "",
    "answer": false,
    "image": "/units/land_nature/images/The wind is strong.png",
    "audio": "/units/land_nature/audio/Mic-kwe-no-we.m4a",
    "lesson_type": "learn",
    "id": "696a926c7bbf3e4de4b8dcac",
    "status": "none",
    "active": true,
    "order": 6,
    "activity_type": "listen",
  },
  {
    "_id": "6976a2016cb884ff5deae4b8",
    "topic": "Land & Nature",
    "question": "",
    "answer": false,
    "image": "/units/land_nature/images/The sun is shining.png",
    "audio": "/units/land_nature/audio/Kijate together.m4a",
    "lesson_type": "learn",
    "id": "696a92bc7bbf3e4de4b8dcb0",
    "status": "none",
    "active": true,
    "order": 7,
    "activity_type": "listen",
  },
  {
    "_id": "6976a2016cb884ff5deae4b9",
    "topic": "Land & Nature",
    "question": "",
    "answer": false,
    "image": "/units/land_nature/images/warm.png",
    "audio": "/units/land_nature/audio/Kijede together.m4a",
    "lesson_type": "learn",
    "id": "696a930b7bbf3e4de4b8dcb3",
    "status": "none",
    "active": true,
    "order": 8,
    "activity_type": "listen",
  },
  {
    "_id": "6976a2016cb884ff5deae4ba",
    "topic": "Land & Nature",
    "question": "",
    "answer": false,
    "image": "/units/land_nature/images/The wind is strong.png",
    "audio": "/units/land_nature/audio/Mickwenowe (together).m4a",
    "lesson_type": "learn",
    "id": "696a93667bbf3e4de4b8dcb6",
    "status": "none",
    "active": true,
    "order": 9,
    "activity_type": "listen",
  },
  {
    "_id": "6976a2016cb884ff5deae4bb",
    "topic": "Land & Nature",
    "question": "",
    "answer": false,
    "image": "/units/land_nature/images/It's raining.png",
    "audio": "/units/land_nature/audio/Kimion together.m4a",
    "lesson_type": "learn",
    "id": "696a93af7bbf3e4de4b8dcb9",
    "status": "none",
    "active": true,
    "order": 10,
    "activity_type": "listen",
  },
  {
    "_id": "6976a2016cb884ff5deae4bc",
    "topic": "Land & Nature",
    "question": "",
    "answer": false,
    "image": "/units/land_nature/images/cold.png",
    "audio": "/units/land_nature/audio/Kisina together.m4a",
    "lesson_type": "learn",
    "id": "696a94397bbf3e4de4b8dcbd",
    "status": "none",
    "active": true,
    "order": 11,
    "activity_type": "listen",
  },
  {
    "_id": "6976a2016cb884ff5deae4bd",
    "topic": "Land & Nature",
    "question": "",
    "answer": false,
    "image": "/units/land_nature/images/The snow is falling.png",
    "audio": "/units/land_nature/audio/Sokpin together.m4a",
    "lesson_type": "learn",
    "id": "696a94977bbf3e4de4b8dcc0",
    "status": "none",
    "active": true,
    "order": 12,
    "activity_type": "listen",
  }
];
